export function getSentryEnvironment(document: Document): string {
    const environment = document
        .querySelector<HTMLMetaElement>('meta[name="sentry-environment"]')
        ?.content
        .trim();

    return environment || 'local';
}
